export const redirectionMap = {
  'utilization.total_fleet': { navigationPath: '/utilization/overview' },
  'production.total_fleet': { navigationPath: '/production/overview' },
};
